'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconMenu = function IconMenu(_ref) {
  var color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({ fill: 'none', height: '24', viewBox: '0 0 24 24', width: '24' }, custom),
    _react2.default.createElement(
      'g',
      { fill: color },
      _react2.default.createElement('path', { d: 'M19.4763594,7.28857143 L4.17221198,7.28857143 C3.54530876,7.28857143 3.03857143,6.90285714 3.03857143,6.43142857 C3.03857143,5.95142857 3.54530876,5.57428571 4.17221198,5.57428571 L19.4763594,5.57428571 C20.1032627,5.57428571 20.61,5.95142857 20.61,6.43142857 C20.61,6.90285714 20.1032627,7.28857143 19.4763594,7.28857143' }),
      ' ',
      _react2.default.createElement('path', { d: 'M16.0992627,13.0028571 L3.93930876,13.0028571 C3.44120101,13.0028571 3.03857143,12.6171429 3.03857143,12.1457143 C3.03857143,11.6657143 3.44120101,11.2885714 3.93930876,11.2885714 L16.0992627,11.2885714 C16.5973704,11.2885714 17,11.6657143 17,12.1457143 C17,12.6171429 16.5973704,13.0028571 16.0992627,13.0028571' }),
      ' ',
      _react2.default.createElement('path', { d: 'M13.2928111,18.7171429 L3.74576037,18.7171429 C3.35468488,18.7171429 3.03857143,18.3314286 3.03857143,17.86 C3.03857143,17.38 3.35468488,17.0028571 3.74576037,17.0028571 L13.2928111,17.0028571 C13.6838865,17.0028571 14,17.38 14,17.86 C14,18.3314286 13.6838865,18.7171429 13.2928111,18.7171429' }),
      ' '
    )
  );
};

IconMenu.propTypes = {
  color: _propTypes2.default.string
};

IconMenu.defaultProps = {
  color: _colors2.default.icons
};

IconMenu.displayName = 'IconMenu';

exports.default = IconMenu;
module.exports = exports.default;